'use strict';

module Patersons {
    export class EquityHoldingsReport {
        holdings: EquityHolding[];
        total: EquityHolding;
    }

    export class EquityHolding {
        securityCode: string;
        exchange: string;
        companyName: string;
        quantity: number;
        averageCost: number;
        lastPrice: number;
        totalCost: number;
        marketValue: number;
        profitOrLoss: number;
        dividendPerShare: number;
        frankedAmount: number;
        income: number;
        yield: number;
        priceToEarnings: number;
        hasData(): boolean {
            return ((typeof this.securityCode != 'undefined' && this.securityCode) ||
                (typeof this.companyName != 'undefined' && this.companyName) ||
                (typeof this.quantity != 'undefined' && this.quantity) ||
                (typeof this.averageCost != 'undefined' && this.averageCost) ||
                (typeof this.lastPrice != 'undefined' && this.lastPrice) ||
                (typeof this.averageCost != 'undefined' && this.averageCost) ||
                (typeof this.totalCost != 'undefined' && this.totalCost) ||
                (typeof this.marketValue != 'undefined' && this.marketValue) ||
                (typeof this.profitOrLoss != 'undefined' && this.profitOrLoss) ||
                (typeof this.dividendPerShare != 'undefined' && this.dividendPerShare) ||
                (typeof this.frankedAmount != 'undefined' && this.frankedAmount) ||
                (typeof this.income != 'undefined' && this.income) ||
                (typeof this.yield != 'undefined' && this.yield) ||
                (typeof this.priceToEarnings != 'undefined' && this.priceToEarnings)
            ) as any;
        }
    }

    export class EquityHoldingsReportComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/portfolioSummary/components/equityHoldingsReport.component.html';
        controller: any = EquityHoldingsReportComponentController;
        bindings: any = {
            title: '@',
            report: '<',
            isInternational: '<',
            predicate: '<',
            sortOrder: '<',
            searchText: '<',
            onOrderChanged: '&'
        };
    }
    export interface EquityHoldingsReportScope extends ng.IScope {
        events: Patersons.EquityHoldingsReportComponentController;
        
        userCompany: UserCompany;
      }
    export class EquityHoldingsReportComponentController extends AbstractReportController {
        report: EquityHoldingsReport;
        morningStarService: Patersons.MorningStarService;
        userCompanyService: Patersons.UserCompanyService;
        scope: Patersons.EquityHoldingsReportScope;
        $rootScope: any;
        static $inject = ['$scope', '$rootScope', 'morningStarService','userCompanyService'];        
        constructor($scope, $rootScope, morningStarService,userCompanyService) {
            super();
            this.scope = $scope;
            this.$rootScope = $rootScope;
            this.scope.events = this;
            this.morningStarService = morningStarService
            this.userCompanyService = userCompanyService;

            this.userCompanyService.getUserCompany().then((company) => {
                this.scope.userCompany = company
                if(company.enableFeature){
                    this.load();
                }
            })
        }
        load() {
            let codes = [];
            this.report.holdings.forEach(report => {
                
                this.morningStarService.getMorningStarDataForSecurityCode(report.exchange, report.securityCode).then(res => {
                    if(res){
                        const elem = $('td:first-child:not(:has(a))').filter(function () {
                            return $(this).text().trim() === report.securityCode;
                        }).first();
                        var openURL = '';
                        var secId = res.FundShareClassId;
                        openURL = mapHoldingTypeIdToReportURL(res.holdingTypeId);

                        if(openURL){
                            openURL += '#/' + secId;
                            elem.html('<a target="_blank" href="' + openURL + '">' + report.securityCode + '</a>');
                            elem.next().html('<a target="_blank" href="' + openURL + '">' + elem.next().text() + '</a>');
                        }
                    }
                })
            })
        }
    }
}
